import { getDownloadURL, ref, getMetadata } from "firebase/storage";
import utcToJst from "modules/utcToJst";
import { storage } from "firebaseConfig";
import { useLayoutEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import DefaultTemplate from "components/templates/DefaultTemplate";

const Congestion = () => {
    const shopName = new URL(window.location.href).searchParams.get(
        "shop_name"
    );
    const [imgSrc, setImgSrc] = useState("");
    const [timestamp, setTimestamp] = useState("");

    const reloadImage = () => {
        if (!shopName) return;
        const r = ref(storage, `congestion/${shopName}.png`);
        getDownloadURL(r)
            .then((url) => {
                setImgSrc(url);
            })
            .catch(() => {
                window.location.href = "/";
            });
        getMetadata(r)
            .then((metadata) => {
                const [yyyymmdd, hhmmss] = metadata.timeCreated.split(/[A-Z]/);
                setTimestamp(utcToJst(yyyymmdd, hhmmss.slice(0, 8)));
            })
            .catch(() => {
                window.location.href = "/";
            });
    };

    useLayoutEffect(reloadImage, [shopName]);

    if (!shopName) return <Navigate to={"/"} />;

    return (
        <DefaultTemplate style={{ textAlign: "center" }}>
            <h2>空席情報</h2>
            <div style={{ width: "100%" }}>
                <img width="100%" src={imgSrc} alt="" />
            </div>
            <button onClick={() => window.history.back()}>戻る</button>
            <span id="timestamp">{timestamp}</span>
            <button id="reload" onClick={reloadImage}>
                更新
            </button>
        </DefaultTemplate>
    );
};

export default Congestion;
